<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeFournisseurMateriel.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(constantes.FOURNISSEUR_MATERIEL.maj) ?
                      $router.push({ name: 'm.gabed.fournisseur_materiel',
                      params: { sousTypeFrom: constantes.TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL } })
                      : showPopUp()"
                      :class="{ 'button-access-no-permission' :
                      !checkPermissions(constantes.FOURNISSEUR_MATERIEL.maj) }">
                {{ $t('listeFournisseurMateriel.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="elementSelectionnes"
            ></selecteur-action>
          </div>
          <form @submit.prevent="updateAutoAndRecherche()"
                class="column is-4 pdr-0">
            <b-input :placeholder="$t('listeFournisseurMateriel.actions.search')"
                     type="search" icon="magnify" v-model="search">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('listeFournisseurMateriel.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.FOURNISSEUR_MATERIEL.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected">
        </b-checkbox>
      </div>
      <div slot="adresse" slot-scope="props">
        {{props.row.adressePostale.adresse1}}
      </div>
      <div slot="codePostal" slot-scope="props">
        {{props.row.adressePostale.codePostal}}
      </div>
      <div slot="ville" slot-scope="props">
        {{props.row.adressePostale.ville}}
      </div>
      <div slot="nomCommercial" slot-scope="props">
        <a class="lien" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.FOURNISSEUR_MATERIEL.lecture) }"
           @click="checkPermissions(constantes.FOURNISSEUR_MATERIEL.lecture) ?
            $router.push({ name: 'c.gabed.fournisseur_materiel',
            params: { id: props.row.id,
            sousTypeFrom: constantes.TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL }})
            : showPopUp()">
          {{props.row.nomCommercial}}
        </a>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(constantes.FOURNISSEUR_MATERIEL.maj) ?
                $router.push({
            name: 'm.gabed.fournisseur_materiel-edition',
            params: { id: props.row.id,
            sousTypeFrom: constantes.TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL } })
             : showPopUp()">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{'text-access-no-permission' :
                  !checkPermissions(constantes.FOURNISSEUR_MATERIEL.maj)}">
          </b-icon>
        </a>
      </div>
      <div slot="archiver">
        <div @click="checkPermissions(constantes.FOURNISSEUR_MATERIEL.supprimer) ? inProgress() :
            showPopUp()" class="is-cursor-pointer">
          <b-icon type="is-default" icon="archive"
                  :class="{ 'text-access-no-permission' :
                           !checkPermissions(constantes.FOURNISSEUR_MATERIEL.supprimer) }">
          </b-icon>
        </div>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(constantes.FOURNISSEUR_MATERIEL.supprimer)
          ? inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{'text-access-no-permission' :
                  !checkPermissions(constantes.FOURNISSEUR_MATERIEL.supprimer)}">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-fournisseur-materiel  ref="filtreListeFournisseurMat"
                        @toggleFiltre="setShowFiltre"
                        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import inProgress from '@/services/general/inProgress';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import {
  TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
  EXPORT_EXCEL_FOURNISSEURS,
  ACTION_EDITION_EXTRAIT_COMPTE_TIERS, LISTE_CHOICE_EDITION_TIERS, TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import { FOURNISSEUR_MATERIEL } from '@/configuration/gabed/permissionsGabedConf';
import filtreFournisseurMateriel from '@/components/gabed/fournisseurMateriel/filtreFournisseurMateriel';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transform from '@/services/tiers/filters/tiersServerTableDataTransformer';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_FOURNISSEUR_MAT } from '@/configuration/general/referenceTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const FournisseurMateriel = createNamespacedHelpers('fournisseurMateriel');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      unsubscribeValue: null,
      showFiltre: false,
      constantes: {
        TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
        FOURNISSEUR_MATERIEL,
      },
      search: '',
      referenceTable: REFERENCE_TABLE_FOURNISSEUR_MAT,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      actions: [
        {
          action: ACTION_EDITION_EXTRAIT_COMPTE_TIERS,
          translation: 'general.popUpEdition.actions.editionExtraitCompteTiers',
        },
      ],
      popUpEdition: false,
      selectAllValue: false,
      tiersSelectionne: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    selecteurAction,
    breadcrumb,
    TableItemsInView,
    filtreFournisseurMateriel,
    parametrageTable,
    exportExcelButton,
    popUpEdition,
  },
  methods: {
    ...FournisseurMateriel.mapActions({
      actionLoadFournisseur: 'loadFournisseur',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeFournisseurMat.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreListeFournisseurMat.initializeFiltre();
      this.$refs.filtreListeFournisseurMat.viderCritere();
      this.$refs.filtreListeFournisseurMat.appliquerCritere();
      this.showFiltre = false;
    },
    manageActions(action) {
      switch (action) {
        case ACTION_EDITION_EXTRAIT_COMPTE_TIERS:
          this.popUpEdition = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.fournisseursMateriel.forEach((el) => {
        el.selected = this.selectAllValue;
      });
      this.tiersSelectionne = this.selectAllValue;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    updateAutoAndRecherche() {
      this.critereRecherche.auto = cloneDeep(this.search);
      this.recherche();
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: this.tiersSelelectedIds,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  computed: {
    ...FournisseurMateriel.mapGetters({
      fournisseursMateriel: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeFournisseurMateriel.breadcrumb.liste'), route: '', isActive: true },
      ];
      return output;
    },
    nombreCritere() {
      const critereBan = ['archive '];
      let nbCritere = calculNombreCritere(this.critereRecherche, critereBan);
      nbCritere += this.critereRecherche.archive !== null ? 1 : 0;
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    elementSelectionnes() {
      return this.fournisseursMateriel.some(c => c.selected);
    },
    tiersSelelectedIds() {
      return this.fournisseursMateriel?.filter(c => !!c.selected).map(t => t.id);
    },
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeFournisseurMateriel.tab.code'),
          nomCommercial: this.$i18n.t('listeFournisseurMateriel.tab.raisonSocial'),
          adresse: this.$i18n.t('listeFournisseurMateriel.tab.adresse'),
          codePostal: this.$i18n.t('listeFournisseurMateriel.tab.cp'),
          ville: this.$i18n.t('listeFournisseurMateriel.tab.ville'),
          telephone: this.$i18n.t('listeFournisseurMateriel.tab.telephone'),
          portable: this.$i18n.t('listeFournisseurMateriel.tab.portable'),
          email: this.$i18n.t('listeFournisseurMateriel.tab.email'),
          compteComptable: this.$i18n.t('listeFournisseurMateriel.tab.compteComptable'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.tiers.length > 0) {
            data.query.tiersId = data.query.tiers.map((t) => t.id);
          }
          delete data.query.tiers;
          return this.actionLoadFournisseur(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.fournisseursMateriel,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
        },
        sortable: ['code', 'nomCommercial', 'adresse', 'codePostal', 'ville', 'telephone', 'portable', 'email', 'compteComptable'],
      };
    },
    columns() {
      return ['selected', 'code', 'nomCommercial', 'adresse', 'codePostal', 'ville', 'telephone', 'portable', 'email', 'compteComptable', 'edit', 'archiver', 'delete'];
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_FOURNISSEURS,
        typeExport: null,
        filtres: transform(this.lastPayload),
        nomFichier: 'Fournisseurs matériel',
      };
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageMultiModule.fournisseurMateriel.liste'));
      this.search = cloneDeep(this.critereRecherche.auto);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
